var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pix-qrcode-container"},[_c('vue-qrcode',{attrs:{"color":_vm.colorInfo,"errorCorrectionLevel":'H',"value":_vm.currentUrl,"width":240,"maskPattern":3,"margin":2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }